import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchStaffCountService } from '../../services/user/staffCountService';
import { validatePendingStaffService } from '../../services/user/validatePendingService';
export const fetchPendingStaffAsync = createAsyncThunk(
  'staff/PendingStaffList',
  async ( thunkAPI) => { // Add thunkAPI as the second argument
    const response = await validatePendingStaffService();
    return response;
  }
);
